import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Routes, Route, Navigate } from "react-router-dom";
import List from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";
import { ClientEditLayout } from "./ClientEditLayout/ClientEditLayout";
import { ContactsList } from "./Contacts/ContactsList/ContactsList";
import { ContactNew } from "./Contacts/ContactNew/ContactNew";
import { ContactEdit } from "./Contacts/ContactEdit/ContactEdit";
import { TermsConditions } from "./TermsAndConditions/TermsConditions";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";

const ClientsMspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="new" element={<New />} />
      <Route path=":id" element={<ClientEditLayout />}>
        <Route index element={<Navigate to="edit" replace />} />
        <Route path="edit" element={<Edit />} />
        <Route path="contacts" element={<ContactsList />} />
        <Route path="contacts/new" element={<ContactNew />} />
        <Route path="contacts/:contactId/edit" element={<ContactEdit />} />
        <Route path="special_conditions" element={<TermsConditions />} />
      </Route>
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default ClientsMspa;
